import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSpinner } from 'react-icons/fa';
import { MdOutlineCloudDownload } from 'react-icons/md';
import usePageTitle from 'hooks/usePageTitle';
import useIsMobile from 'utils/isMobileUtils';

const ExportProduct = () => {
	const [setPageTitle] = usePageTitle('Products - Export');
		const history = useNavigate();
	const [isExportRunning, setIsExportRunning] = useState(false);
	const [selectedProductStatus, setSelectedProductStatus] = useState(1);
	const [selectedOption, setSelectedOption] = useState(0);
	useEffect(() => {
		return () => {
			setPageTitle(null);
		};
	}, []);

	const productStatusType = [
		{ label: 'Active products', value: 1 },
		{ label: 'Inactive products', value: 0 }
	];
	const options = [
		{ label: 'Yes', value: 1 },
		{ label: 'No', value: 0 }
	];

	const ExportProduct = () => {
		setIsExportRunning(true);
		const data = {
			startDate: '2021-01-01',
			endDate: '2021-12-31'
		};
		api.exportProducts(data, selectedProductStatus, selectedOption).then((res) => {
			var newBlob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
			saveAs(newBlob, `Projectmix - Product List.xlsx`);
			setIsExportRunning(false);
		});
	};

	const isMobile = useIsMobile();
	return (
		<>
			<div className="row">
				<div className="col-12">
					<div className="row pb10">
						<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
							<div className="header-bubble" />
							<div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
								<div
									style={{
										position: 'relative',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										marginBottom: 8,
										minHeight: 38 // ensures enough height for the button
									}}
								>
									{' '}
									<button
										type="button"
										aria-label="Back"
										onClick={() => history(-1)}
										className="circle-back-btn"
										style={{
											position: 'absolute',
											left: 20,
											top: '50%',
											transform: 'translateY(-50%)'
										}}
									>
										{/* Replace with your fi arrow icon, example below */}
										<svg width="22" height="22" fill="none" viewBox="0 0 24 24">
											<path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
										</svg>
									</button>
									<h5 className="m-0 p-0 pb-2" style={{ fontWeight: '500' }}>
										Import
									</h5>
								</div>
								<div style={{ width: '100%', display: 'flex', justifyContent: 'center', gap: 10 }}>
									{isExportRunning ? (
										<button className="btn btn-outlined-main disabled" disabled>
											<FaSpinner style={{ animation: 'spin 2s linear infinite' }} /> Exporting...
										</button>
									) : (
										<button className="btn btn-outlined-main" onClick={() => ExportProduct()}>
											<MdOutlineCloudDownload /> Export
										</button>
									)}
								</div>
							</div>
						</div>
						<div className="col-12">
							<div className="section-head-new"></div>
						</div>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-12">
					<div className={`${isMobile ? '' : 'card p-2'}`}>
						<div className="content pad15">
							<div className="row m-0 p-0 mb-3 hide-on-mobile">
								<div className="col-md-2 col-sm-3 col-12">
									<h4 className="font18">
										<b>Export</b>
									</h4>
								</div>
							</div>
							{!isMobile ? (
								<div className="row">
									<div className="col-md-4 col-3 text-right form-group">Product type</div>
									<div className="col-md-4 col-9 form-group">
										{productStatusType?.map((status, index) => (
											<div key={index}>
												<input
													type="radio"
													name="act-product"
													onClick={() => {
														setSelectedProductStatus(status?.value);
													}}
													checked={status?.value === selectedProductStatus ? true : false}
												/>{' '}
												<span htmlFor="">{status.label}</span>
											</div>
										))}
									</div>
								</div>
							) : (
								<div style={{ display: 'flex', flexDirection: 'column', padding: '0px 20px' }}>
									<div style={{ fontWeight: 500, fontSize: 16 }}>Product type</div>
									<div style={{ display: 'flex', width: '100%', gap: 10, flexWrap: 'wrap' }}>
										{productStatusType?.map((status, index) => (
											<div
												key={index}
												style={{
													display: 'flex',
													width: '48%',
													alignItems: 'center',
													gap: 5,
													padding: '5px 10px',
													borderRadius: 5,
													border: '1px solid #ccc',
													cursor: 'pointer',
													backgroundColor: status?.value === selectedProductStatus ? '#e3f2fd' : '#fff'
												}}
												onClick={() => {
													setSelectedProductStatus(status?.value);
												}}
											>
												<input type="radio" name="act-product" checked={status?.value === selectedProductStatus ? true : false} />{' '}
												<span htmlFor="">{status.label}</span>
											</div>
										))}
									</div>
								</div>
							)}
							{!isMobile ? (<div className="row">
								<div className="col-md-4 col-3 text-right form-group">Include warehouse and stock information</div>
								<div className="col-md-4 col-9 form-group">
									{options?.map((option, index) => (
										<div key={index}>
											<input
												type="radio"
												name="act-product-yes"
												onClick={() => {
													setSelectedOption(option?.value);
												}}
												checked={option?.value === selectedOption ? true : false}
											/>{' '}
											<span htmlFor="">{option.label}</span>
										</div>
									))}
								</div>
							</div>) : (
								<div style={{ display: 'flex', flexDirection: 'column', padding: '0px 20px', marginTop: 20 }}>
									<div style={{ fontWeight: 500, fontSize: 16 }}>Include warehouse and stock information</div>
									<div style={{ display: 'flex', width: '100%', gap: 10, flexWrap: 'wrap' }}>
										{options?.map((option, index) => (
											<div
												key={index}
												style={{
													display: 'flex',
													width: '48%',
													alignItems: 'center',
													gap: 5,
													padding: '5px 10px',
													borderRadius: 5,
													border: '1px solid #ccc',
													cursor: 'pointer',
													backgroundColor: option?.value === selectedOption ? '#e3f2fd' : '#fff'
												}}
												onClick={() => {
													setSelectedOption(option?.value);
												}}
											>
												<input type="radio" name="act-product-yes" checked={option?.value === selectedOption ? true : false} />{' '}
												<span htmlFor="">{option.label}</span>
											</div>
										))}
									</div>
								</div>
							)}
							<div className="row m-0 p-0 mb-3 hide-on-mobile">
								<div className="col-12">
									<div style={{ display: 'flex', justifyContent: 'center' }}>
										{isExportRunning ? (
											<button className="btn btn-outlined-main disabled" disabled>
												<FaSpinner style={{ animation: 'spin 2s linear infinite' }} /> Exporting...
											</button>
										) : (
											<button className="btn btn-outlined-main" onClick={() => ExportProduct()}>
												<MdOutlineCloudDownload /> Export
											</button>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default ExportProduct;